import React from "react"
import { plus } from "../hooks/icons"
import { useSearchspringFilters } from "@app/scripts/hooks/use-searchspring-filters"

export type Props = {
  isModelView: boolean
  handleToggleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export function CollectionFilterModel({
  isModelView,
  handleToggleChange,
}: Props) {
  const { activeFilters } = useSearchspringFilters()

  const handleOpenDrawer = () => {
    const drawer = document.getElementById("filter-sort-drawer")

    if (drawer) {
      drawer.classList.add("open", "active")
      drawer.setAttribute("aria-hidden", "false")

      document.body.classList.add("open-cc")
    }
  }

  return (
    <>
      <div className="collection-banner--filter-model-secondary-container">
        <button
          onClick={handleOpenDrawer}
          className="collection-banner--filter open-drawer-button"
        >
          {plus} Filter
          {activeFilters.size > 0 ? ` (${activeFilters.size})` : " & Sort"}
        </button>

        <div className="item-divider is-hidden md:is-visible"></div>

        <div className="collection-banner--model-toggle">
          Model
          <input
            type="checkbox"
            className="custom-checkbox"
            checked={isModelView}
            onChange={handleToggleChange}
          />
        </div>
      </div>
    </>
  )
}
